import { css } from "styled-components";

export const restrained = css`
  visibility: hidden;
  width: 3.6em;
`;

export const between = css`
  transform: scale(0.6);
  transform-origin: top right;
`;

export const small = css`
  margin-top: 2rem;
`;
